import React, { useEffect, useRef, useState } from 'react';
import { Text } from 'barte-design-system';
import { CaretDown } from '@phosphor-icons/react';
import './MultiSelectTipos.css';

export interface MultiOption {
  value: string;
  label: string;
}

interface MultiSelectTiposProps {
  label?: string;
  placeholder?: string;
  options: MultiOption[];
  value: string[];
  onChange: (next: string[]) => void;
}

export function MultiSelectTipos({
  label = 'Tipo',
  placeholder = 'Selecione',
  options,
  value,
  onChange,
}: MultiSelectTiposProps) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onDocClick(e: MouseEvent) {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  function toggle(v: string) {
    if (value.includes(v)) onChange(value.filter((x) => x !== v));
    else onChange([...value, v]);
  }

  const selectedLabels = options
    .filter((o) => value.includes(o.value))
    .map((o) => o.label);

  return (
    <div className="ms-wrapper" ref={rootRef}>
      {label && <Text variant="label-sm" className="ms-label">{label}</Text>}
      <button
        type="button"
        className={`ms-field${open ? ' is-open' : ''}`}
        onClick={() => setOpen((o) => !o)}
      >
        <span className={`ms-field-value${selectedLabels.length === 0 ? ' is-placeholder' : ''}`}>
          {selectedLabels.length === 0
            ? placeholder
            : selectedLabels.join(', ')}
        </span>
        <CaretDown size={14} weight="bold" />
      </button>

      {open && (
        <div className="ms-dropdown">
          {options.map((opt) => {
            const checked = value.includes(opt.value);
            return (
              <button
                key={opt.value}
                type="button"
                className="ms-option"
                onClick={() => toggle(opt.value)}
              >
                <span className={`ms-checkbox${checked ? ' is-checked' : ''}`} aria-hidden>
                  {checked && (
                    <svg width="10" height="10" viewBox="0 0 12 12">
                      <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </span>
                <Text variant="body-sm">{opt.label}</Text>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
